import { DateRangeOption, DateRangeType } from "components/TableFilters/types";
import dayjs from "dayjs";

export const dateOptions: DateRangeOption[] = [
  {
    id: "all_time",
    title: "За весь період",
    type: DateRangeType.ALL_TIME,
  },
  {
    id: "last_7_days",
    title: "Останні 7 днів",
    type: DateRangeType.LAST_7_DAYS,
  },
  {
    id: "last_30_days",
    title: "Останні 30 днів",
    type: DateRangeType.LAST_30_DAYS,
  },
  {
    id: "last_90_days",
    title: "Останні 90 днів",
    type: DateRangeType.LAST_90_DAYS,
  },
  { id: "date_range", title: "Період", type: DateRangeType.CUSTOM_PERIOD },
];

export const expirationOptions: DateRangeOption[] = [
  {
    id: "all_time",
    title: "Всі",
    type: DateRangeType.ALL_TIME,
  },
  {
    id: "no_expiration",
    title: "Без терміну дії",
    type: DateRangeType.CUSTOM_VALUE,
    value: { range: { from: null, to: null }, noExpiration: true },
  },
  {
    id: "expired",
    title: "Термін дії закінчився",
    type: DateRangeType.CUSTOM_VALUE,
    value: { range: { from: null, to: dayjs() } },
  },
  { id: "date_range", title: "Період", type: DateRangeType.CUSTOM_PERIOD },
];
